import { init } from '@sentry/browser';
import AppSettingsProvider from '%app/js/common/services/AppSettingsProvider';

const configureSentry = (config = {}) => {
    init({
        dsn: (new AppSettingsProvider()).getAppSettings().getSentryJsDsn(),
        beforeSend(event, hint) {
            if (hint && hint.originalException) {
                const { originalException: { mute, response } } = hint;

                if (mute) {
                    return null;
                }

                if (response && response.status === 400) {
                    return null;
                }
            }
            if (event?.message?.match(/Loading (?:CSS )?chunk \d+ failed/i)) {
                event.message = 'Loading chunk failed';
            }

            return event;
        },
        beforeBreadcrumb(breadcrumb, hint) {
            const { category, data = {} } = breadcrumb;
            if (category === 'xhr') {
                const { status_code: statusCode } = data;
                const { xhr: { response } = {} } = hint;
                if (statusCode === 400) {
                    data.response = response;
                }
            }

            return breadcrumb;
        },
        ...config,
    });
};

export default configureSentry;
